import React, { useState } from 'react'

import LocationModal from '../../containers/LocationModalContainer'
import { checkSimulationOnlyRoute } from '../../utils'
import AddressLine from './AddressLine'
import { getCurrentRouteByLocation } from '@/checkout-instore-legacy/utils/getCurrentRouteByLocation'
import { useLocation } from 'react-router-dom'

type CartLocationProps = {
  cartAddress: Address
  simulationAddress: Address
  isLoadingAddress: boolean
  withBorder?: boolean
  countryCode: string
  context?: string
}

function CartLocation({
  cartAddress,
  simulationAddress,
  isLoadingAddress,
  withBorder = false,
  countryCode,
  context,
}: CartLocationProps) {
  const [isModalOpen, setModalOpen] = useState(false)
  const location = useLocation()
  const isSimulationOnlyMode = checkSimulationOnlyRoute(
    getCurrentRouteByLocation(location.pathname)
  )
  const address = isSimulationOnlyMode ? simulationAddress : cartAddress

  const closeModal = () => {
    setModalOpen(false)
  }

  const openModal = () => {
    setModalOpen(true)
  }

  return (
    <React.Fragment>
      <AddressLine
        address={address}
        loading={isLoadingAddress}
        onClick={openModal}
        withBorder={withBorder}
        countryCode={countryCode}
      />
      <LocationModal
        // TODO: this error popped up when moving the checkout-instore project
        // to checkout-instore-legacy, but needs to be fixed at some point
        // @ts-ignore
        isModalOpen={isModalOpen}
        handleCloseModal={closeModal}
        isSimulationOnlyMode={isSimulationOnlyMode}
        context={context}
      />
    </React.Fragment>
  )
}

export default CartLocation
